import { createSlice, nanoid } from "@reduxjs/toolkit";

const initialState = {
  users: [
    { id: "u1", name: "Admin User", email: "admin@example.com", role: "Admin" },
    { id: "u2", name: "Normal User", email: "user@example.com", role: "User" },
  ],
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    addUser: {
      reducer(state, action) {
        state.users.push(action.payload);
      },
      prepare({ name, email, role }) {
        return {
          payload: { id: nanoid(), name, email, role: role || "User" },
        };
      },
    },
    updateUser(state, action) {
      const { id, updates } = action.payload;
      const index = state.users.findIndex((u) => u.id === id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...updates };
      }
    },
    removeUser(state, action) {
      const id = action.payload;
      state.users = state.users.filter((u) => u.id !== id);
    },
  },
});

export const { addUser, updateUser, removeUser } = usersSlice.actions;
export default usersSlice.reducer;
